var _path, _path2, _path3, _mask, _rect, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecruitment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4979 15.9992C29.4979 22.9944 23.8273 28.6651 16.8324 28.6651C9.8374 28.6651 4.16683 22.9944 4.16683 15.9992C4.16683 9.00401 9.8374 3.33333 16.8324 3.33333C23.8273 3.33333 29.4979 9.00401 29.4979 15.9992Z",
    stroke: "#2E2E2E",
    strokeWidth: 1.66667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3572 26.4732L26.8016 24.3522L34.7156 33.4731C35.0655 33.8763 35.0222 34.4868 34.6191 34.8366L33.6347 35.6908C33.2316 36.0406 32.6211 35.9974 32.2713 35.5942L24.3572 26.4732Z",
    stroke: "#2E2E2E",
    strokeWidth: 1.66667
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7263 28.8994L28.6465 27.1225",
    stroke: "#2E2E2E",
    strokeWidth: 1.66667
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_44981_9419",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.7915,
    y: 10,
    width: 4.58344,
    height: 5.44444,
    rx: 1.52778
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.7915,
    y: 10,
    width: 4.58344,
    height: 5.44444,
    rx: 1.52778,
    stroke: "currentColor",
    strokeWidth: 3.33333,
    mask: "url(#path-4-inside-1_44981_9419)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 17.9894C13.3333 17.5066 13.6061 17.1167 13.9905 16.9746C14.914 16.6331 16.1241 16.2776 17.0833 16.2776C18.0426 16.2776 19.2526 16.6331 20.1761 16.9746C20.5606 17.1167 20.8333 17.5066 20.8333 17.9894V20.8332H13.3333V17.9894Z",
    stroke: "currentColor",
    strokeWidth: 1.66667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecruitment);
export default __webpack_public_path__ + "static/media/Recruitment.847bad448f1e17aa89ac63e2fcd98481.svg";
export { ForwardRef as ReactComponent };